import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base/baseQuery';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: baseQuery,
  tagTypes: ['Dashboard'],
  endpoints: (builder) => ({
    getDashboardOverview: builder.query({
      query: () => 'backoffice/dashboard/overview',
      providesTags: ['Dashboard'],
    }),
    getUsersGrowth: builder.query({
      query: (days = 30) => `backoffice/dashboard/users-growth?days=${days}`,
      providesTags: ['Dashboard'],
    }),
    getContentDistribution: builder.query({
      query: () => 'backoffice/dashboard/content-distribution',
      providesTags: ['Dashboard'],
    }),
    getQuestionsByType: builder.query({
      query: () => 'backoffice/dashboard/questions-by-type',
      providesTags: ['Dashboard'],
    }),
    getRecentActivities: builder.query({
      query: () => 'backoffice/dashboard/recent-activities',
      providesTags: ['Dashboard'],
    }),
    getTopSubjects: builder.query({
      query: () => 'backoffice/dashboard/top-subjects',
      providesTags: ['Dashboard'],
    }),
  }),
});

export const {
  useGetDashboardOverviewQuery,
  useGetUsersGrowthQuery,
  useGetContentDistributionQuery,
  useGetQuestionsByTypeQuery,
  useGetRecentActivitiesQuery,
  useGetTopSubjectsQuery,
} = dashboardApi;
